import { render, staticRenderFns } from "./_detailRow.vue?vue&type=template&id=684b24bd&scoped=true&"
import script from "./_detailRow.vue?vue&type=script&lang=js&"
export * from "./_detailRow.vue?vue&type=script&lang=js&"
import style0 from "./_detailRow.vue?vue&type=style&index=0&id=684b24bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684b24bd",
  null
  
)

export default component.exports